import PropTypes from 'prop-types';

const genericFormStatePropTypes = PropTypes.shape({
    product: PropTypes.arrayOf(PropTypes.string).isRequired,
    source: PropTypes.arrayOf(PropTypes.string).isRequired,
    page: PropTypes.arrayOf(PropTypes.string).isRequired,
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    isCustomer: PropTypes.bool.isRequired,
});

export default genericFormStatePropTypes;
